__turbopack_context__.v({
  "container": "BriefPromoCard-module-scss-module__IonwbW__container",
  "gif": "BriefPromoCard-module-scss-module__IonwbW__gif",
  "imageSection": "BriefPromoCard-module-scss-module__IonwbW__imageSection",
});
